<template>
    <v-app class="gst-layout-loading">
        <div class="justify-center loader d-flex align-center">
            <DataLoading />
            <main>
                <slot></slot>
            </main>
        </div>
    </v-app>
</template>

<script>
import { DataLoading } from '@components/loading';

export default {
    name: 'Loading',
    components: {
        DataLoading,
    },
};
</script>
<style lang="scss" scoped>
.gst-layout-loading {
    height: 100vh;

    .loader {
        height: 100vh;
    }
}
</style>
